import React, { useEffect, useState, useRef, useMemo } from 'react';
import { Line } from 'react-chartjs-2';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import './DwMeasurementInfo.css';
import '../../App.css';
import { useSelector } from 'react-redux';
import config from '../../config';
import { CSVLink } from "react-csv";
import { ko } from 'date-fns/locale';
import axios from 'axios';
import io from 'socket.io-client';
import { Table } from 'react-bootstrap';

const statusMessages = {
  0: "정상", 1: "스트링 차단", 2: "주회로 우회", 3: "내부온도 과열차단",
  4: "방열판 과열차단", 5: "스트링 과전류차단", 6: "아크 차단", 7: "습도 차단",
  8: "누설전류 차단", 9: "진동 차단", 10: "마이크로컨버터 삽입", 11: "역전력 차단",
  12: "음파감지 차단", 13: "낙뢰예보 차단", 14: "원격 차단", 20: "스트링온도 과열우회", 21: "스트링 과전류 우회"
};



const DwMeasurementInfo = ({ SelJb }) => {


  const Jb_list = useSelector((state) => state.Jb_list || {});
  const JbMrtData = useSelector((state) => state.JbMrtData || {});
  const plantInfo = useSelector((state) => state.plantInfo);


  const [index, setIndex] = useState(null);
  const [alarms, setAlarms] = useState([]);
  const [showPopup, setShowPopup] = useState(false);
  const [popupBlocked, setPopupBlocked] = useState(false);
  const [clickedButtons, setClickedButtons] = useState({});

  const [forecastData, setForecastData] = useState([]);
  const [xyData, setXyData] = useState([]);

  const parseData = (data) => {
    try {
      const items = JSON.parse(data).response.body.items.item;
      const formattedData = {};

      // 최초로 좌표(nx, ny)를 설정하는 부분
      const { nx, ny } = items[0];
      setXyData({ nx, ny });

      items.forEach((item) => {
        const { fcstTime, category, fcstValue } = item;
        if (!formattedData[fcstTime]) formattedData[fcstTime] = { 시간: fcstTime };

        switch (category) {
          case 'T1H':
            formattedData[fcstTime].기온 = `${fcstValue}°C`;
            break;
          case 'RN1':
            formattedData[fcstTime].시간당강수량 = fcstValue === '강수없음' ? '없음' : `${fcstValue}mm`;
            break;
          case 'SKY':
            formattedData[fcstTime].하늘상태 = {
              '1': '맑음',
              '3': '구름많음',
              '4': '흐림',
            }[fcstValue] || '알 수 없음';
            break;
          case 'UUU':
            formattedData[fcstTime].동서바람 = `${fcstValue}m/s`;
            break;
          case 'VVV':
            formattedData[fcstTime].남북바람 = `${fcstValue}m/s`;
            break;
          case 'REH':
            formattedData[fcstTime].습도 = `${fcstValue}%`;
            break;
          case 'PTY':
            formattedData[fcstTime].강수형태 = parseInt(fcstValue);
            break;
          case 'LGT':
            formattedData[fcstTime].낙뢰 = `${fcstValue}kA`;
            break;
          case 'VEC':
            formattedData[fcstTime].풍향 = `${fcstValue}°`;
            break;
          case 'WSD':
            formattedData[fcstTime].풍속 = `${fcstValue}m/s`;
            break;
        }
      });

      return Object.values(formattedData).sort((a, b) => a.시간 - b.시간);
    } catch (error) {
      console.error('데이터 파싱 중 오류 발생:', error);
      return [];
    }
  };


  useEffect(() => {
    const socket = io(`${config.backendUrl}`, {
      transports: ['websocket']
    });

    socket.on('connect', () => {
      console.log('WebSocket 서버에 연결되었습니다 (대원전기)');
      socket.emit('request_time');
    });

    socket.on('weather_data', (message) => {
      // console.log('원본 메시지:', message);
      const parsedData = parseData(message);
      setForecastData(parsedData);
    });

    return () => {
      socket.off('weather_data');
      socket.off('connect');
      socket.close();
    };
  }, []);














  useEffect(() => {
    if (Jb_list.seq && Array.isArray(Jb_list.seq)) {
      const foundIndex = Jb_list.seq.findIndex(seq => SelJb === seq);
      setIndex(foundIndex !== -1 ? foundIndex : null);
    }
  }, [Jb_list, SelJb]);

  useEffect(() => {
    if (JbMrtData.specialMode && Array.isArray(JbMrtData.specialMode[index])) {
      const newAlarms = JbMrtData.specialMode[index]
        .filter(statusData => statusData && statusData.mode !== 0)
        .map((statusData, i) => ({
          channel: i + 1,
          message: statusMessages[statusData.mode] || "알 수 없는 상태"
        }));

      // 정전 상태 확인 및 알람 추가
      if (JbMrtData.specialMode[index][31] && JbMrtData.specialMode[index][31].blackout === 0) {
        newAlarms.push({
          channel: '시스템',
          message: '정전이 발생했습니다!'
        });
      }

      if (newAlarms.length > 0 && !popupBlocked) {
        setAlarms(newAlarms);
        setShowPopup(true);
      }
    }
  }, [JbMrtData, index, popupBlocked]);


  const writeModbusRegisters = (jb_address, functionCode, startAddress, writeValues) => {
    if (!jb_address) {
      console.log("jb_address가 유효하지 않습니다");
      return;
    }

    const modbusSlaveID = jb_address;
    let modbusPacket;

    if (functionCode === 6) {
      // Function Code 6 (Write Single Register)
      if (writeValues.length !== 1) {
        console.error("Function Code 6은 단일 값만 허용합니다.");
        return;
      }
      modbusPacket = new Uint8Array([
        modbusSlaveID,
        functionCode,
        (startAddress >> 8) & 0xFF,
        startAddress & 0xFF,
        (writeValues[0] >> 8) & 0xFF,
        writeValues[0] & 0xFF
      ]);
    } else if (functionCode === 16) {
      // Function Code 16 (Write Multiple Registers)
      const registerCount = writeValues.length;
      modbusPacket = new Uint8Array([
        modbusSlaveID,
        functionCode,
        (startAddress >> 8) & 0xFF,
        startAddress & 0xFF,
        (registerCount >> 8) & 0xFF,
        registerCount & 0xFF,
        registerCount * 2  // 바이트 수
      ]);
      writeValues.forEach(value => {
        modbusPacket = new Uint8Array([...modbusPacket, (value >> 8) & 0xFF, value & 0xFF]);
      });
    } else {
      console.error("지원되지 않는 Function Code입니다.");
      return;
    }

    const crc = calculateCRC(modbusPacket);
    const finalPacket = new Uint8Array([...modbusPacket, crc[0], crc[1]]);

    axios.post(`${config.backendUrl}/api/client_to_server_data`, {
      packet: Array.from(finalPacket),
      jb_address: jb_address
    })
      .then(response => {
        if (response.status === 200) {
          console.log('✅ Modbus 패킷이 성공적으로 전송되었습니다:');
        } else {
          console.error('❌ Modbus 패킷 전송 실패: 예상치 못한 상태 코드', response.status);
        }
      })
      .catch(error => {
        console.error('❌ Modbus 패킷 전송 중 오류 발생:', error);
      });
  };


  const activeChannels = useMemo(() => {
    const channelUseArray = Jb_list.jb_pv_ch_use && Jb_list.jb_pv_ch_use[index]
      ? Jb_list.jb_pv_ch_use[index].split(',')
      : [];
    const channelNameArray = Jb_list.jb_pv_ch_name && Jb_list.jb_pv_ch_name[index]
      ? Jb_list.jb_pv_ch_name[index].split(',')
      : [];

    return channelUseArray
      .map((use, i) => (use === '1' ? { name: channelNameArray[i], index: i } : null))
      .filter((channel) => channel !== null);
  }, [Jb_list, index]);

  const closePopup = () => {
    setShowPopup(false);
    setPopupBlocked(true);
    setTimeout(() => {
      setPopupBlocked(false);
    }, 30000);
  };


  const handleResetWithAnimation = (channelIndex, i) => {
    writeModbusRegisters(channelIndex, 6, 133 + i, [0]);
    setClickedButtons(prev => ({ ...prev, [channelIndex]: true }));
    setTimeout(() => {
      setClickedButtons(prev => ({ ...prev, [channelIndex]: false }));
    }, 300);
  };

  const handleAcTripResetWithAnimation = (channelIndex, control) => {

    writeModbusRegisters(channelIndex, 6, 8, [control]);
    setClickedButtons(prev => ({ ...prev, [channelIndex]: true }));
    setTimeout(() => {
      setClickedButtons(prev => ({ ...prev, [channelIndex]: false }));
    }, 300);

  };


  const cellStyle = {
    minWidth: '150px',
    width: '150px',
    padding: '8px',
    textAlign: 'center',
    verticalAlign: 'middle',
    wordWrap: 'break-word',
    overflowWrap: 'break-word'
  };



  const getWeatherEmoji = (skyCondition) => {
    switch (skyCondition) {
      case '맑음': return '☀️';
      case '구름많음': return '⛅';
      case '흐림': return '☁️';
      default: return '❓';
    }
  };

  const getRainEmoji = (rainType) => {
    const type = parseInt(rainType);
    switch (type) {
      case 0: return { emoji: '🌂', description: '없음' };
      case 1: return { emoji: '🌧️', description: '비' };
      case 2: return { emoji: '🌨️', description: '비/눈' };
      case 3: return { emoji: '❄️', description: '눈' };
      case 5: return { emoji: '💧', description: '빗방울' };
      case 6: return { emoji: '🌨️', description: '빗방울눈날림' };
      case 7: return { emoji: '❄️', description: '눈날림' };
      default: return { emoji: '❓', description: '알 수 없음' };
    }
  };


  const getWindDirection = (degree) => {
    const directions = ['↓', '↙', '←', '↖', '↑', '↗', '→', '↘'];
    return directions[Math.round(degree / 45) % 8];
  };




  return (
    <div>

      <div>
        <div style={{ margin: '10px', maxWidth: '1560px' }}>
          <div className='JbGenTable'>
            <h4 style={{ backgroundColor: '#3D98DE', color: 'white', padding: '10px', marginBottom: '0', fontWeight: 'bold', borderRadius: '10px' }}>
              {plantInfo && plantInfo.address && (
                <span style={{ marginLeft: '20px', fontSize: '0.9em' }}>
                  ☀️ [ {plantInfo.address} ] 시간별 예보 정보
                  {xyData.nx && xyData.ny && (
                    <span style={{ marginLeft: '10px', fontSize: '0.8em' }}>
                      (기상청 좌표 nx: {xyData.nx}, ny: {xyData.ny})
                    </span>
                  )}
                </span>
              )}
            </h4>
            <table className="summary-table weather-table">
              <thead>
                <tr>
                  <th>시간</th>
                  <th>낙뢰</th>
                  <th>기온</th>
                  <th>하늘상태</th>
                  <th>습도</th>
                  <th>바람</th>
                  <th>강수형태</th>
                  <th>강수량</th>
                </tr>
              </thead>
              <tbody>
                {forecastData.map((data, index) => (
                  <tr key={index}>
                    <td>{data.시간.slice(0, 2) === '00' ? '00시' :
                      data.시간.slice(0, 2) === '01' ? '01시' :
                        data.시간.slice(0, 2) === '02' ? '02시' :
                          data.시간.slice(0, 2) === '03' ? '03시' :
                            data.시간.slice(0, 2) === '04' ? '04시' :
                              data.시간.slice(0, 2) === '05' ? '05시' :
                                data.시간.slice(0, 2) === '06' ? '06시' :
                                  data.시간.slice(0, 2) === '07' ? '07시' :
                                    data.시간.slice(0, 2) === '08' ? '08시' :
                                      data.시간.slice(0, 2) === '09' ? '09시' :
                                        data.시간.slice(0, 2) === '10' ? '10시' :
                                          data.시간.slice(0, 2) === '11' ? '11시' :
                                            data.시간.slice(0, 2) === '12' ? '12시' :
                                              data.시간.slice(0, 2) === '13' ? '13시' :
                                                data.시간.slice(0, 2) === '14' ? '14시' :
                                                  data.시간.slice(0, 2) === '15' ? '15시' :
                                                    data.시간.slice(0, 2) === '16' ? '16시' :
                                                      data.시간.slice(0, 2) === '17' ? '17시' :
                                                        data.시간.slice(0, 2) === '18' ? '18시' :
                                                          data.시간.slice(0, 2) === '19' ? '19시' :
                                                            data.시간.slice(0, 2) === '20' ? '20시' :
                                                              data.시간.slice(0, 2) === '21' ? '21시' :
                                                                data.시간.slice(0, 2) === '22' ? '22시' :
                                                                  data.시간.slice(0, 2) === '23' ? '23시' : data.시간}</td>
                    <td>{data.낙뢰 || 'N/A'}</td>
                    <td>{data.기온 || 'N/A'}</td>
                    <td>
                      <span className="weather-icon">{getWeatherEmoji(data.하늘상태)}</span>
                      {data.하늘상태 || 'N/A'}
                    </td>
                    <td>{data.습도 || 'N/A'}</td>
                    <td>
                      <div className="wind-info">{getWindDirection(parseFloat(data.풍향))}{'    '} {data.풍속 || 'N/A'}</div>
                    </td>
                    <td>
                      <span className="weather-icon">{getRainEmoji(data.강수형태).emoji}</span>
                      {getRainEmoji(data.강수형태).description} ({data.강수형태})
                    </td>
                    <td>{data.시간당강수량 || 'N/A'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div style={{ margin: '10px', maxWidth: '1560px' }}>
        <div className='JbGenTable'>
          <div className="summary-table-container">
            <table className="summary-table" style={{ marginBottom: '10px' }}>
              <tbody>
                <tr>
                  <th style={{ backgroundColor: '#3D98DE' }}>통합전압</th>
                  <th style={{ backgroundColor: '#3D98DE' }}>통합전류</th>
                  <th style={{ backgroundColor: '#3D98DE' }}>통합전력</th>
                  <th style={{ backgroundColor: '#3D98DE' }}>누설전류</th>
                  <th style={{ backgroundColor: '#3D98DE' }}>AC차단기 제어</th>
                  <th style={{ backgroundColor: '#3D98DE' }}>습도</th>
                  <th style={{ backgroundColor: '#3D98DE' }}>정전상태</th>
                  <th style={{ backgroundColor: '#3D98DE' }}>내부온도</th>
                </tr>
                <tr>
                  <td style={{ fontSize: '18px', fontWeight: 'bold' }}>{(JbMrtData.PvTotalVolt[index] / 10).toFixed(1)} V</td>
                  <td style={{ fontSize: '18px', fontWeight: 'bold' }}>{(JbMrtData.pvTotalCurrent[index] / 10).toFixed(1)} A</td>
                  <td style={{ fontSize: '18px', fontWeight: 'bold' }}>{(JbMrtData.PvTotalVolt[index] * JbMrtData.pvTotalCurrent[index] / 100000).toFixed(2)} kW</td>
                  <td style={{ fontSize: '18px', fontWeight: 'bold' }}>{JbMrtData.specialMode && JbMrtData.specialMode[index] && JbMrtData.specialMode[index][31] && JbMrtData.specialMode[index][31].leakage_current !== undefined ? `${(JbMrtData.specialMode[index][31].leakage_current / 10).toFixed(1)} mA` : 'N/A'}</td>
                  <td style={{ fontSize: '18px', fontWeight: 'bold' }}>
                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                      <span>
                        {JbMrtData.specialMode && JbMrtData.specialMode[index] && JbMrtData.specialMode[index][31] && JbMrtData.specialMode[index][31].Ac_Control !== undefined ? ['정상', '자동차단', '수동차단'][JbMrtData.specialMode[index][31].Ac_Control] || 'N/A' : 'N/A'}
                      </span>
                      <button style={{ marginLeft: '10px' }}
                        onClick={() => handleAcTripResetWithAnimation(Jb_list.jb_address[index], 2)}
                        className={`reset-button ${clickedButtons[index] ? 'clicked' : ''}`}
                      >
                        차단
                      </button>
                      <button style={{ marginLeft: '10px' }}
                        onClick={() => handleAcTripResetWithAnimation(Jb_list.jb_address[index], 0)}
                        className={`reset-button ${clickedButtons[index] ? 'clicked' : ''}`}
                      >
                        복귀
                      </button>

                    </div>
                  </td>
                  <td style={{ fontSize: '18px', fontWeight: 'bold' }}>{JbMrtData.specialMode && JbMrtData.specialMode[index] && JbMrtData.specialMode[index][31] && JbMrtData.specialMode[index][31].humidity !== undefined ? `${(JbMrtData.specialMode[index][31].humidity / 10).toFixed(1)}%` : 'N/A'}</td>
                  <td style={{ fontSize: '18px', fontWeight: 'bold' }}>
                    {JbMrtData.specialMode && JbMrtData.specialMode[index] && JbMrtData.specialMode[index][31] && JbMrtData.specialMode[index][31].blackout !== undefined ? (
                      JbMrtData.specialMode[index][31].blackout === 1 ? (
                        '정상'
                      ) : (
                        <span style={{ color: 'red' }}>
                          정전
                        </span>
                      )
                    ) : 'N/A'}
                  </td>
                  <td style={{ fontSize: '18px', fontWeight: 'bold' }}>{JbMrtData.temperature ? `${(JbMrtData.temperature[index] / 10).toFixed(1)} ℃` : 'N/A'}</td>
                </tr>
              </tbody>
            </table>
          </div>
          <div className="Dw-table-container" style={{ marginTop: '-15px' }}>
            <table className="Dw-channel-info-table">
              <thead>
                <tr>
                  <th style={cellStyle}>{Jb_list.jb_name[index]}</th>
                  {activeChannels.map((channel) => (
                    <th key={channel.index}>{channel.name}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>전압 (V)</td>
                  {activeChannels.map((channel, i) => (
                    <td key={`volt-${channel.index}`}>{(JbMrtData.pvChVolt[index][i] / 10).toFixed(1)}</td>
                  ))}
                </tr>
                <tr>
                  <td>전류 (A)</td>
                  {activeChannels.map((channel, i) => (
                    <td key={`current-${channel.index}`}>{(JbMrtData.pvChCurrent[index][i] / 10).toFixed(1)}</td>
                  ))}
                </tr>
                <tr>
                  <td>전력 (kW)</td>
                  {activeChannels.map((channel, i) => (
                    <td key={`power-${channel.index}`}>{(JbMrtData.pvChVolt[index][i] * JbMrtData.pvChCurrent[index][i] / 100000).toFixed(2)}</td>
                  ))}
                </tr>
                <tr>
                  <td>특수모드</td>
                  {activeChannels.map((channel, i) => (
                    <td key={`channel-${channel.index}`}>
                      {JbMrtData.specialMode && JbMrtData.specialMode[index] && JbMrtData.specialMode[index][i] && JbMrtData.specialMode[index][i].mode !== undefined ? (
                        statusMessages[JbMrtData.specialMode[index][i].mode] || "알 수 없음"
                      ) : "데이터 없음"}
                    </td>
                  ))}
                </tr>
                <tr>
                  <td style={{ verticalAlign: 'middle' }}>상태</td>
                  {activeChannels.map((channel, i) => (
                    <td key={`reset-button-${channel.index}`}>
                      {JbMrtData.specialMode &&
                        JbMrtData.specialMode[index] &&
                        JbMrtData.specialMode[index][i] &&
                        JbMrtData.specialMode[index][i].mode !== undefined ? (
                        JbMrtData.specialMode[index][i].mode === 0 ? "🟢" :
                          JbMrtData.specialMode[index][i].mode === 99 ? "🔴" : "⚙️"
                      ) : "데이터 없음"}
                      <br />
                      <button style={{ marginTop: '5px' }}
                        onClick={() => handleResetWithAnimation(Jb_list.jb_address[index], i)}
                        className={`reset-button ${clickedButtons[channel.index] ? 'clicked' : ''}`}
                      >
                        리셋
                      </button>
                    </td>
                  ))}
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <ChannelCurrentGraph activeChannels={activeChannels} seq={JbMrtData.seq[index]} height={'320px'} />
      {showPopup && <AlarmPopup alarms={alarms} onClose={closePopup} />}
    </div>
  );
};

const ChannelCurrentGraph = ({ activeChannels, seq, height }) => {
  const timeLabels = useMemo(() => [
    '05:00', '05:10', '05:20', '05:30', '05:40', '05:50',
    '06:00', '06:10', '06:20', '06:30', '06:40', '06:50',
    '07:00', '07:10', '07:20', '07:30', '07:40', '07:50',
    '08:00', '08:10', '08:20', '08:30', '08:40', '08:50',
    '09:00', '09:10', '09:20', '09:30', '09:40', '09:50',
    '10:00', '10:10', '10:20', '10:30', '10:40', '10:50',
    '11:00', '11:10', '11:20', '11:30', '11:40', '11:50',
    '12:00', '12:10', '12:20', '12:30', '12:40', '12:50',
    '13:00', '13:10', '13:20', '13:30', '13:40', '13:50',
    '14:00', '14:10', '14:20', '14:30', '14:40', '14:50',
    '15:00', '15:10', '15:20', '15:30', '15:40', '15:50',
    '16:00', '16:10', '16:20', '16:30', '16:40', '16:50',
    '17:00', '17:10', '17:20', '17:30', '17:40', '17:50',
    '18:00', '18:10', '18:20', '18:30', '18:40', '18:50',
    '19:00', '19:10', '19:20', '19:30', '19:40', '19:50',
    '20:00'
  ], []);

  const [isDataAvailable, setIsDataAvailable] = useState(false);
  const [isLoading, setIsLoading] = useState(true);
  const [selectedDate, setSelectedDate] = useState(new Date());
  const [hiddenState, setHiddenState] = useState({});
  const [chartDataByTime, setChartDataByTime] = useState({});
  const chartRef = useRef(null);
  const [PvTotalVolt, setPvTotalVolt] = useState(Array(timeLabels.length).fill(0));
  const [PvTotalCurrent, setPvTotalCurrent] = useState(Array(timeLabels.length).fill(0));

  const selectedDateStr = selectedDate.toISOString().split('T')[0];

  const isWithinTimeRange = (createdAt, targetTime) => {
    const [targetHours, targetMinutes] = targetTime.split(':').map(Number);
    const dateObj = new Date(createdAt);
    const itemHours = dateObj.getUTCHours();
    const itemMinutes = dateObj.getUTCMinutes();
    const startTime = targetHours * 60 + targetMinutes;
    const endTime = startTime + 10;
    const itemTimeMinutes = itemHours * 60 + itemMinutes;
    return itemTimeMinutes >= startTime && itemTimeMinutes < endTime;
  };

  const findClosestTimeData = (filteredData, targetTime, channelIndex, seq) => {
    const closestData = filteredData.find(item => isWithinTimeRange(item.created_at, targetTime) && item.seq === seq);
    if (!closestData) {
      return {
        value: Array(32).fill(0),
        item: null,
        PvTotalVolt: 'N/A',
        PvTotalCurrent: 'N/A',
      };
    }
    const pvChCurrentArray = closestData.PvChCurrent
      ? closestData.PvChCurrent.split(',').map(Number)
      : Array(32).fill(0);
    return {
      value: pvChCurrentArray,
      item: closestData,
      PvTotalVolt: closestData.PvTotalVolt || 'N/A',
      PvTotalCurrent: closestData.PvTotalCurrent || 'N/A',
    };
  };

  const fetchData = async (date) => {
    setIsLoading(true);
    try {
      const selectedDateInKST = new Date(date.getTime() - date.getTimezoneOffset() * 60000)
        .toISOString()
        .split('T')[0];
      const response = await fetch(`${config.backendUrl}/get_hourly_jb_mrt_data`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          date: selectedDateInKST,
        }),
      });
      const result = await response.json();

      if (!result.data || result.data.length === 0) {
        setEmptyData();
        return;
      }

      const filtered = result.data;
      const chartData = {};
      activeChannels.forEach((channel) => {
        chartData[channel.index] = [];
      });

      const newPvTotalVolt = Array(timeLabels.length).fill('N/A');
      const newPvTotalCurrent = Array(timeLabels.length).fill('N/A');

      timeLabels.forEach((label, timeIndex) => {
        activeChannels.forEach((channel) => {
          const { value: pvChCurrentArray, PvTotalVolt, PvTotalCurrent } = findClosestTimeData(filtered, label, channel.index, seq);
          chartData[channel.index][timeIndex] = pvChCurrentArray[channel.index] || null;

          newPvTotalVolt[timeIndex] = PvTotalVolt;
          newPvTotalCurrent[timeIndex] = PvTotalCurrent;
        });
      });

      setChartDataByTime(chartData);
      setPvTotalVolt(newPvTotalVolt);
      setPvTotalCurrent(newPvTotalCurrent);

      setIsDataAvailable(true);
    } catch (error) {
      setEmptyData();
    } finally {
      setIsLoading(false);
    }
  };

  const setEmptyData = () => {
    const emptyChartData = {};
    activeChannels.forEach((channel) => {
      emptyChartData[channel.index] = Array(timeLabels.length).fill(null);
    });
    setChartDataByTime(emptyChartData);
    setPvTotalVolt(Array(timeLabels.length).fill('N/A'));
    setPvTotalCurrent(Array(timeLabels.length).fill('N/A'));
  };

  useEffect(() => {
    if (seq) {
      fetchData(selectedDate);
    }
  }, [selectedDate, seq]);

  useEffect(() => {
    const intervalId = setInterval(() => fetchData(new Date()), 660000);
    return () => clearInterval(intervalId);
  }, []);

  const generateCSVData = () => {
    const csvData = [];
    timeLabels.forEach((label, index) => {
      const row = {
        time: label,
        PvTotalVolt: PvTotalVolt[index],
        PvTotalCurrent: PvTotalCurrent[index],
      };
      activeChannels.forEach((channel) => {
        row[`Channel ${channel.index} Current`] = chartDataByTime[channel.index]?.[index] || null;
      });
      csvData.push(row);
    });
    return csvData;
  };

  const csvHeaders = [
    { label: "Time", key: "time" },
    { label: "PvTotalVolt", key: "PvTotalVolt" },
    { label: "PvTotalCurrent", key: "PvTotalCurrent" },
    ...activeChannels.map((channel) => ({
      label: `Channel ${channel.index} Current`,
      key: `Channel ${channel.index} Current`,
    }))
  ];

  const chartData = {
    labels: timeLabels,
    datasets: activeChannels.map((channel, index) => ({
      label: channel.name,
      data: chartDataByTime[channel.index] || [],
      borderColor: [
        '#EF5350', '#26C6DA', '#FF7043', '#AB47BC', '#FFCA28',
        '#3A736A', '#7E57C2', '#60A07A', '#FFA726', '#8D6E63',
        '#66BB6A', '#D44A46', '#7F8C8D', '#4B4B3D', '#918D62',
        '#DAB672', '#F1D597', '#F4B381', '#F19557', '#E05D44',
        '#C25054', '#AC6D82', '#26A69A', '#6B4E3D',
      ][index % 24],
      borderWidth: 1,
      fill: false,
      tension: 0.4,
      hidden: hiddenState[channel.index] || false,
      pointRadius: (chartDataByTime[channel.index] || []).map(value => value === null ? 0 : 1),
    })),
  };

  const chartOptions = {
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      y: {
        display: true,
        title: {
          display: true,
          text: '전류 (A)',
        },
        min: 0,
        ticks: {
          callback: function (value) {
            return (value / 10).toFixed(1);
          },
        },
      },
    },
    plugins: {
      legend: {
        position: 'top',
        labels: {
          boxWidth: 15,
          padding: 15,
          font: {
            size: 12,
          },
          usePointStyle: true,
        },
        onClick: (e, legendItem) => {
          const index = legendItem.datasetIndex;
          const channelIndex = activeChannels[index].index;
          setHiddenState((prevState) => ({
            ...prevState,
            [channelIndex]: !prevState[channelIndex],
          }));
        },
      },
      tooltip: {
        mode: 'index',
        intersect: false,
        position: 'nearest',
        yAlign: 'center',
        xAlign: 'right',
        caretPadding: 30,
        caretSize: 10,
        callbacks: {
          title: function (tooltipItems) {
            const dataIndex = tooltipItems[0].dataIndex;
            const timeLabel = timeLabels[dataIndex];
            const Pvvolt = PvTotalVolt[dataIndex] || 'N/A';
            const Pvcurrent = PvTotalCurrent[dataIndex] || 'N/A';

            return [
              `시간: ${timeLabel}`,
              `통합전압: ${(Pvvolt / 10).toFixed(1)}V`,
              `통합전류: ${(Pvcurrent / 10).toFixed(1)}A`,
            ];
          },
          label: function (tooltipItem) {
            const value = chartDataByTime[tooltipItem.datasetIndex][tooltipItem.dataIndex] || 0;
            return [`${tooltipItem.dataset.label}: ${(value / 10).toFixed(1)}A`];
          }
        },
        bodyFont: {
          size: 10,
        },
        titleFont: {
          size: 12,
        },
      }
    },
  };

  const handleSelectAll = () => {
    const allHiddenState = {};
    activeChannels.forEach((channel) => {
      allHiddenState[channel.index] = false;
    });
    setHiddenState(allHiddenState);
  };

  const handleDeselectAll = () => {
    const allHiddenState = {};
    activeChannels.forEach((channel) => {
      allHiddenState[channel.index] = true;
    });
    setHiddenState(allHiddenState);
  };

  return (
    <div className="channel-current-graph" style={{ margin: '10px', maxWidth: '1560px', backgroundColor: 'white' }}>
      <div className="control-container" style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', marginBottom: '5px' }}>
        <DatePicker
          selected={selectedDate}
          onChange={(date) => setSelectedDate(date)}
          dateFormat="yyyy-MM-dd"
          locale={ko}
          className="styled-datepicker"
          popperPlacement="bottom"
          maxDate={new Date()}
          customInput={
            <input
              style={{
                textAlign: 'center',
                height: '25px',
                lineHeight: '25px',
                width: '150px',
                marginRight: '10px',
              }}
            />
          }
        />
        <div style={{ display: 'flex', alignItems: 'center', marginLeft: '5px' }}>
          <button onClick={handleSelectAll} className="styled-button" style={{ marginRight: '5px', height: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            전체 선택
          </button>
          <button onClick={handleDeselectAll} className="styled-button" style={{ height: '25px', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            전체 해제
          </button>
          <CSVLink
            data={generateCSVData()}
            headers={csvHeaders}
            filename={`data_${selectedDateStr}.csv`}
            className="styled-button"
            style={{
              marginLeft: '20px',
              height: '25px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              textDecoration: 'none',
              backgroundColor: '#1D6C41',
            }}
          >
            CSV 다운로드
          </CSVLink>
        </div>
      </div>
      <div className="graph-container" style={{ height }}>
        {isLoading ? (
          <div className="loading-message">데이터를 불러오는 중...</div>
        ) : !isDataAvailable ? (
          <div className="no-data-message">데이터가 없습니다.</div>
        ) : (
          <Line ref={chartRef} data={chartData} options={chartOptions} />
        )}
      </div>
    </div>
  );
};

function calculateCRC(buffer) {
  let crc = 0xFFFF;
  for (let pos = 0; pos < buffer.length; pos++) {
    crc ^= buffer[pos];
    for (let i = 8; i !== 0; i--) {
      if ((crc & 0x0001) !== 0) {
        crc >>= 1;
        crc ^= 0xA001;
      } else {
        crc >>= 1;
      }
    }
  }
  return [(crc & 0xFF), (crc >> 8) & 0xFF];
}

const AlarmPopup = ({ alarms, onClose }) => {
  return (
    <div className="alarm-popup-overlay">
      <div className="alarm-popup">
        <h3>경고 알람</h3>
        <table className="alarm-table">
          <thead>
            <tr>
              <th>채널</th>
              <th>알람</th>
            </tr>
          </thead>
          <tbody>
            {alarms.map((alarm, index) => (
              <tr key={index}>
                <td>{alarm.channel}</td>
                <td>{alarm.message}</td>
              </tr>
            ))}
          </tbody>
        </table>
        <button className="close-button" onClick={onClose}>닫기</button>
      </div>
    </div>
  );
};

export default DwMeasurementInfo;
